import { App } from 'src/types/app';
import { Region } from 'src/types/env';

export const SAMD_PLATFORM_VERSIONS = {
  [App.SamdUk]: '1.2.0',
  [App.SamdUs]: '1.2.3',
  [App.SamdDemo]: '1.0.0',
  [App.SamdEu]: '1.2.0',
};

export const PROSTATE_VERSIONS = {
  [Region.UK]: '1.3.3',
  [Region.EU]: '1.3.3',
  [Region.US]: '1.1.2',
};

export const BREAST_CANCER_VERSIONS = {
  [Region.UK]: '1.1.1',
  [Region.EU]: '1.1.1',
  [Region.US]: '1.1.2',
};

export const RELEASE_DATE = {
  [Region.UK]: '2026-08-20',
  [Region.EU]: '2026-07-01',
  [Region.US]: '2026-08-31',
};
